import TextBlock from './base/text-block';
import BlockMutationResult from '../block-mutation-result';
import BlockRange from '../block-range';
import { computed } from '@ember/object';
import CodeCloseReplacement from '@intercom/embercom-composer/blocks/replacements/code-close';
import Constants from '@intercom/embercom-composer/lib/constants';
import { empty } from '@ember/object/computed';
import Em from 'ember';
export default TextBlock.extend({
  allowedEntities: ['attribute'],
  type: 'code',
  isCodeBlock: true,
  splitType: 'code',
  language: 'javascript',
  openingTag: computed('id', function () {
    return `<pre class="code" data-id="${this.id}">`; //TODO: GJ: decide on HTML format for this block
  }),
  closingTag: '</pre>',
  isEmptyCodeBlock: empty('text'),
  blockReplacements: [CodeCloseReplacement],
  serialized: Em.computed('text', 'language', function () {
    let json = this._super();
    json.language = this.get('language');
    return json;
  }),
  join(block) {
    if (block.get('isListType')) {
      return this._joinWithList(block, false);
    }
    if (this._canJoinWithBlock(block)) {
      return this._join(block);
    }
    return BlockMutationResult.create({
      blocksToRemove: [block]
    });
  },
  rightTrim() {
    let length = this.get('text.length');
    let startIndex = length - 1;
    let text = this.get('text');
    let trimChars = [' ', '`', Constants.NEW_LINE];
    while (trimChars.includes(text.charAt(startIndex))) {
      startIndex--;
      if (startIndex === 0) {
        break;
      }
    }
    this.delete(BlockRange.atPositionIndex(startIndex + 1, length));
  },
  _join(block) {
    let text = this.get('text');
    let blocksToRemove = [];
    if (text === '') {
      blocksToRemove.pushObject(this);
    } else {
      blocksToRemove.pushObject(block);
    }
    this.set('text', text + block.get('text'));
    return BlockMutationResult.create({
      blocksToRemove,
      blockRange: BlockRange.atPositionIndex(text.length)
    });
  },
  _canJoinWithBlock(block) {
    return block.get('type') === this.get('type') || block.get('type') === 'paragraph';
  }
});